import '../scss/main.scss';
import './react/agenda';

import Nav from './components/Nav';
import Accordion from './components/Accordion';
import IsDraggable from './components/IsDraggable';
import HideOnScroll from './components/HideOnScroll';
import VideoPlayer from './components/VideoPlayer';
import TicketBar from './components/TicketBar';
import Newsletter from './components/Newsletter';
import Glide from '@glidejs/glide';

document.querySelectorAll('.js-glide').forEach((el) => {
	new Glide(el, {type: 'carousel'}).mount();
 });

document.querySelectorAll('.js-nav').forEach((el) => {
  new Nav(el);
});

document.querySelectorAll('.js-ticket-bar').forEach((el) => {
	new TicketBar(el);
 });

document.querySelectorAll('.js-accordion').forEach((el) => {
  new Accordion(el);
});

document.querySelectorAll('.js-is-draggable').forEach((el) => {
  new IsDraggable(el);
});

document.querySelectorAll('.js-hide-on-scroll').forEach((el) => {
  new HideOnScroll(el);
});

document.querySelectorAll('.js-video-player').forEach((el) => {
	new VideoPlayer(el);
});

document.querySelectorAll('.js-newsletter-subscribe').forEach((el) => {
	new Newsletter(el);
});
